export default __webpack_public_path__ + "static/media/support.41ddfbe5.svg";